export enum ConsignmentType {
  ORDER = 'order',
  TRANSFER = 'transfer',
  RETURN = 'return',
}
